export const Content = `query Content($id: ID!) {
  pContent(id: $id) {
    id
    
    # 项目名称
    name
    
    # 学科
    subject {
      id
      name
    }
    
    # 平台
    platforms {
      id
      name
    }
    
    # 行业
    trade {
      id
      name
      color
      iconFile {
        url
      }
    }
    
    # 行业标题
    industryTitle
    
    # 行业图标
    industryIcon {
      url
    }
    
    # 软件
    tools {
      name
      logoImage {
        url
      }
    }
    
    # 产品滚动图
    coverImageGroupList {
      groupName
      imageType
      imageAndLink {
        url
        image {
          url
        }
      }
    }
    
    # 演示链接
    demoTitleLinkGroup {
      title
      url
      info
    }
    
    # 详情列表
    detailsList {
      # 顶部楼层导航文字
      navTitle
      # 类型 textImage图文、 bgTextImage带背景图文、outline大纲、 itemsList基础课程、 usersList名师
      type
      # 主标题
      title
      # 子标题
      subTitle
      # 标题背景文字
      topBackgroundTitle
      # 图文数据
      tuWen {
        description
        link
        # 主图、人物
        image {
          url
        }
        # 背景
        bgImage {
          url
        }
        # 文字背景图
        textBgImage {
          url
        }
      }
      # 列表项
      lieBiao {
        title
        subTitle
        description
        url
        image {
          url
        }
      }
    }

    # 名师
    teachers {
      name
      quarters
      headerImage {
        url
      }
      details
      isPublic
      sortNum
    }
    
    # 版本号
    version
    
    # 最后更新
    lastUpdate
    
    # 简介
    description
    
    # 更新日志
    gitlabLogs

    # 标题图片
    titleImage {
      url
    }
    
    # 详情页logo图
    detailLogoImage {
      url
    }
    
    # 列表页图片
    logoImage {
      url
    }
    
    # 封面图
    pAdImages {
      url
    }
    
    # 视频图
    videoLogoImage {
      url
    }
    # 视频url
    pVideoUrl
    

		######################################3
    # 旧版数据
    
    # 产品架构图
    productArchitectureDiagramImage {
      url
    }
    
    # 产品结构图
    productStructureImage {
      url
    }
    
    # 演示链接
    demoLink1
    demoLink2
    demoLink3
    demoLink4
    demoLink5
    demoLink6
    # 基本信息
    baseInfoTitle1
    baseInfoDesc1
    baseInfoTitle2
    baseInfoDesc2
    baseInfoTitle3
    baseInfoDesc3
    baseInfoTitle4
    baseInfoDesc4
    baseInfoTitle5
    baseInfoDesc5
    baseInfoTitle6
    baseInfoDesc6
    baseInfoTitle7
    baseInfoDesc7
    baseInfoTitle8
    baseInfoDesc8
    # 技术亮点
    technicalHighlights
    # 技术解决方案
    technologySolution
    # 技术架构图
    testArchitectureImage {
      url
    }
    # 功能架构图
    functionalArchitectureDiagram {
      url
    }
    # 技术架构图
    technicalArchitectureDiagram {
      url
    }
    projectSummaryImage {
      url
    }
    StudentWorkImage {
      url
    }
    
    #################################
    
    # 课程试学链接
    courseTrial
    
    # 课程大纲
    courseOutlineTitle1
    courseOutlineDesc1
    courseOutlineTitle2
    courseOutlineDesc2
    courseOutlineTitle3
    courseOutlineDesc3
    courseOutlineTitle4
    courseOutlineDesc4
    courseOutlineTitle5
    courseOutlineDesc5
    courseOutlineTitle6
    courseOutlineDesc6
    courseOutlineTitle7
    courseOutlineDesc7
    courseOutlineTitle8
    courseOutlineDesc8
    courseOutlineTitle9
    courseOutlineDesc9
    courseOutlineTitle10
    courseOutlineDesc10
    courseOutlineTitle11
    courseOutlineDesc11
    courseOutlineTitle12
    courseOutlineDesc12
    courseOutlineTitle13
    courseOutlineDesc13
    courseOutlineTitle14
    courseOutlineDesc14
    courseOutlineTitle15
    courseOutlineDesc15
    courseOutlineTitle16
    courseOutlineDesc16
    courseOutlineTitle17
    courseOutlineDesc17
    courseOutlineTitle18
    courseOutlineDesc18
    courseOutlineTitle19
    courseOutlineDesc19
    courseOutlineTitle20
    courseOutlineDesc20
    
    # 产品图片
    productImagesTitle1
    productImages1 {
      url
    }
    productImagesTitle2
    productImages2 {
      url
    }
    productImagesTitle3
    productImages3 {
      url
    }
    productImagesTitle4
    productImages4 {
      url
    }
    productImagesTitle5
    productImages5 {
      url
    }
    
    # 概述统计
    summarizeStatistics
  }
}`
